<template>
  <v-dialog
    :value="requires2FA"
    persistent
    max-width="500"
    @keydown.esc="() => {}"
  >
    <v-card class="modal-2fa">
      <v-card-title class="text-center">
        ยืนยันตัวตน 2FA
      </v-card-title>

      <v-card-subtitle class="text-center text-gray mt-2">
        ระบบรักษาความปลอดภัย กรุณากรอกรหัส 6 หลัก
      </v-card-subtitle>

      <v-card-text>
        <OTP2FAContent :phone="userPhoneFor2FA" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import OTP2FAContent from './OTP2FAContent.vue'

export default {
  name: 'Modal2FA',

  components: {
    OTP2FAContent,
  },

  computed: {
    ...mapState('auth', ['requires2FA', 'userPhoneFor2FA']),
  },
}
</script>

<style scoped lang="stylus">
.modal-2fa
  border-radius 12px
  box-shadow 0 8px 24px rgba(0, 0, 0, 0.15)

  .text-gray
    color #999 !important
</style>
